import axios from "./axios.js";
import Token from "../module/token";
Token.en();
export function getChannel(params) {
  // 获取渠道
  return axios({
    url: "/api/channel/common/get",
    method: "get",
    params
  });
}

// 获取手机验证码
export function getCodeNumber(data) {
  return axios({
    url: "/api/card/common/phone/get",
    method: "post",
    data
  });
}
// 校验手机验证码
export function verifyCodeNum(url, data) {
  return axios({
    url,
    method: "post",
    data
  });
}

export function getPhoneYzm(data) {
  return axios({
    url: "/api/channel/web/verifyCode/send" + "/" + data.phonenum,
    method: "get",
    data
  });
}

export function searchCard(url, data) {
  // 搜索号码
  return axios({
    url,
    method: "post",
    data
  });
}
export function submitCard(url, data) {
  Token.de(sessionStorage.getItem("v1-token"))
  // 提交申请
  return axios({
    url,
    method: "post",
    data,
    headers:{
      key:sessionStorage.getItem("v1-token")
    }
  });
}
//滑块验证接口
export function getAliCaptchaInfo( data) {

  return axios({
    url: "/api/card/common/v2/getAliCaptchaInfo",
    method: "post",
    data,
  
  });
}
export function recordMonitor(data) {
  // 服务端监测记录日志
  return axios({
    url: "/api/monitor/record",
    method: "post",
    data
  });
}
// 调用第三方的统一接口
export function commonMonitor(params) {
  return axios({
    url:
      "/api/monitor/common_monitor?company=" +
      params.query.company +
      "&requestMethod=" +
      params.query.requestMethod,
    method: "post",
    data: params.info
  });
}

export function getCidyData(params) {
  return axios({
    // url: '/api/city/common/json/get',
    url: "/api/card/common/v2/json/get",
    method: "get",
    params
  });
}
export function getProvince(columns, cardType) {
  return axios({
    url: `/api/card/common/v2/resource/province/list/${columns}/${cardType}`,
    method: "get"
  });
}

//获取数据
export function getData(url, method, data) {
  return axios({
    url,
    method: method,
    data
  });
}

export const getPositionByApi = ({ url, method, data, params }) =>
  axios({
    url,
    method,
    data,
    params
  });

// 判断 卡种是否有归属地
export const getItHasOwnTown = data =>
  axios({
    url: "/api/card/common/v2/resource/province/list/match",
    method: "post",
    data
  });

export const hasYzm = params =>
  axios({
    url: "/api/card/common/v2/verify/get",
    method: "get",
    params
  });

export const adApi = data =>
  axios({
    url: `/api/monitor/gdt`,
    method: "post",
    params:data
  });

  


// WEBPACK FOOTER //
// ./src/api/url.js